"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _useContainer2 = require("../../hooks/useContainer");
var _Base = require("./Base");
var _RichText = require("../RichText");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _clsx = _interopRequireDefault(require("clsx"));
var Modal = function Modal(props) {
  var _useContainer = (0, _useContainer2.useContainer)(),
    container = _useContainer.container;
  var children = typeof props.children === 'string' ? /*#__PURE__*/_react.default.createElement(_RichText.RichText, {
    content: props.children,
    jumpNodeMap: props.jumpNodeMap
  }) : props.children;
  return props.active ? /*#__PURE__*/_react.default.createElement(_Base.Base, (0, _extends2.default)({}, props, {
    type: "modal",
    container: props.container || container,
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('modal'), props.className)
  }), children) : null;
};
exports.Modal = Modal;